import * as React from "react";
import { OrganisationSurvey } from "../../model/ModelTypes";
import { ExpansionPanel, Chip } from "react-md";
import { isNullOrUndefined } from "util";
import * as moment from "moment";
import "./static/OrganisationSurveyPanel.scss";
export interface OrganisationSurveyPanelProps {
    survey: OrganisationSurvey;
    onDeleteClicked?: Function;
    columnWidths?: number[];
    focused?: boolean;
}
interface OrganisationSurveyPanelState {
    isCollapsed: boolean;
}
class OrganisationSurveyPanel extends React.PureComponent<OrganisationSurveyPanelProps, OrganisationSurveyPanelState> {
    render() {
        return (
            <ExpansionPanel
                columnWidths={this.props.columnWidths}
                focused={this.props.focused}
                animateContent={true}
                label=""
                secondaryLabel={
                    <div className="NotificationPanelHeaderContainer">
                        <div className="NotificationPanelHeaderTitle">
                        <p className='NotificationHeaderTitle'>{this.props.survey.name}</p>
                        {
                            !isNullOrUndefined(this.props.survey.link) &&
                            <p className="mobileRemovable" >{this.props.survey.link}</p>
                        }
                        </div>
                        <div className="NotificationPanelHeaderTime">
                        <p className="NotificationPanelHeaderTimeTitle mobileRemovable">
                         Date Added :
                        </p>
                        <p> {moment(this.props.survey.created_time).format("DD/MMM/YYYY HH:mm:ss")} </p>
                        </div>
                    </div>
                }
                saveLabel="Delete"
                saveProps={
                    {
                      disabled: isNullOrUndefined(this.props.onDeleteClicked)

                    }
                }
                onSave={() => this.props.onDeleteClicked(this.props.survey)}
            >
                <div className="NotificaitonPanelBody">
                    <div className="NotificaitonPanelBodyContent">
                        <h5>Added By User: </h5>
                        <p>{this.props.survey.username}</p>
                    </div>
                    {
                        !isNullOrUndefined(this.props.survey.roles) &&
                        <div className="NotificaitonPanelBodyContent">
                            <h5>Applicable to Roles</h5>
                            {
                                this.props.survey.roles.length > 0 &&
                                this.props.survey.roles.map(
                                    (role, index) => <Chip label={role} key={`role${index}`}/>
                                )
                            }
                            {
                                this.props.survey.roles.length < 1 &&
                                 <Chip label="All Roles" key="All" />
                            }
                        </div>
                    }
                    {
                        !isNullOrUndefined(this.props.survey.name) &&
                        <div className="NotificaitonPanelBodyContent">
                            <h5>Survey Name</h5>
                            <p>{this.props.survey.name}</p>
                        </div>
                    }
                    {
                        !isNullOrUndefined(this.props.survey.link) &&
                        <div className="NotificaitonPanelBodyContent">
                            <h5>Survey Link URL </h5>
                            <p>{this.props.survey.link}</p>
                        </div>
                    }
                    {
                        <div className="NotificaitonPanelBodyContent">
                            <h5>Date Added </h5>
                            <p>{moment(this.props.survey.created_time).format("DD/MMM/YYYY HH:mm:ss")}</p>
                        </div>
                    }

                </div>
            </ExpansionPanel>
        );
    }
}
export default OrganisationSurveyPanel;


// WEBPACK FOOTER //
// ./src/component/OrganisationSurveyPanel/OrganisationSurveyPanel.tsx